class ClosetProductCategory extends HTMLElement {
  connectedCallback() {
    this.animationStyle = this.dataset.animationStyle || 'off';
    this.isInView = false;
    this.hasPlayed = false;

    if (this.animationStyle === 'off') return;

    this.setupInViewObserver();
  }

  disconnectedCallback() {
    this.inViewObserver?.disconnect();
  }

  setupInViewObserver() {
    if (!('IntersectionObserver' in window)) {
      this.playEntrance();
      return;
    }

    this.inViewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const wasInView = this.isInView;
          this.isInView = entry.isIntersecting;

          if (entry.isIntersecting && !wasInView) {
            this.playEntrance();
          }
        });
      },
      { threshold: 0.2 }
    );

    this.inViewObserver.observe(this);
  }

  playEntrance() {
    if (this.animationStyle === 'off') return;

    this.classList.remove('is-animated');
    this.classList.add('is-pending');
    void this.offsetHeight;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.classList.remove('is-pending');
        this.classList.add('is-animated');
        this.hasPlayed = true;
      });
    });
  }
}

if (!customElements.get('closet-product-category')) {
  customElements.define('closet-product-category', ClosetProductCategory);
}
